export default {
  "errors": {
    "notFound": "Evento no encontrado.",
    "disabled": "Las confirmaciones de asistencia en línea no están habilitadas para este evento.",
    "loadError": "No se pudo cargar la página.",
    "searchError": "No hemos podido encontrar tu invitación. Por favor, comprueba la ortografía exacta utilizada en tu invitación.",
    "genericError": "Ha ocurrido un error.",
    "submitError": "Error al enviar tu respuesta."
  },
  "success": {
    "title": "¡Gracias!",
    "message": "Tu respuesta ha sido registrada con éxito.",
    "dateMessage": "¡Nos vemos el {{date}}!"
  },
  "header": {
    "title": "Confirmación de Asistencia",
    "defaultWelcome": "¡Esperamos celebrarlo contigo! Por favor, confirma tu asistencia."
  },
  "search": {
    "title": "Encuentra tu invitación",
    "firstName": "Nombre",
    "firstNamePlaceholder": "Juan",
    "lastName": "Apellido",
    "lastNamePlaceholder": "García (Opcional)",
    "submit": "Buscar",
    "searching": "Buscando..."
  },
  "form": {
    "greeting": "¡Hola, {{firstName}} {{lastName}}!",
    "subtitle": "Por favor, haznos saber si podrás acompañarnos.",
    "attendance": "¿Asistirás?",
    "yes": "¡Sí, con mucho gusto!",
    "no": "No, lo siento",
    "plusOne": {
      "title": "Tu acompañante (+1)",
      "label": "Nombre y Apellido del acompañante",
      "placeholder": "María Gómez"
    },
    "dietary": {
      "title": "Requisitos dietéticos",
      "subtitle": "Marca las opciones que se apliquen a ti (y a tu acompañante si corresponde).",
      "vegetarian": "Vegetariano",
      "vegan": "Vegano",
      "glutenFree": "Sin Gluten",
      "porkFree": "Sin Cerdo",
      "nutAllergy": "Alergia a los frutos secos",
      "seafoodAllergy": "Alergia a los mariscos",
      "customPlaceholder": "Otros detalles (alergias específicas...)"
    },
    "message": {
      "title": "¿Un mensaje para los novios?",
      "placeholder": "Deja un bonito mensaje..."
    },
    "submit": "Confirmar mi respuesta",
    "submitting": "Confirmando..."
  }
};
